import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import { getMultiLangProperty } from "../../../helpers/generalHelper";
import ShopGridStandardViewModel from "../viewModel";

const ListItem = ({ slug = "", name }) => {
  const { t } = useTranslation();
  const { selectedKey, cleanBrandsFilter } = useContext(
    ShopGridStandardViewModel.Context
  );
  return (
    <li key={slug}>
      <div className="sidebar-widget-list-left">
        <Link
          onClick={() => cleanBrandsFilter()}
          className={selectedKey === slug ? "theme-color" : ""}
          to={{ pathname: `/browse/${slug}` }}
        >
          {name || t("productList.allProducts")}
        </Link>
      </div>
    </li>
  );
};

const ShopCategories = ({ categories }) => {
  const { t, i18n } = useTranslation();
  const [activeKey, setActiveKey] = useState(null);
  const [subActiveKey, setSubActiveKey] = useState(null);
  const { selectedKey, history } = useContext(
    ShopGridStandardViewModel.Context
  );

  useEffect(() => {
    setActiveKey(null);
    setSubActiveKey(null);

    if (selectedKey) {
      categories.forEach(({ children, _id }) => {
        const childCategory = children.find(
          (child) => child.category?.slug === selectedKey
        );

        if (childCategory) {
          setActiveKey(_id);
          setSubActiveKey(null);
        } else {
          const subChildCategory = children.find(
            ({ category: { children: subChildren = [] } = {} }) =>
              subChildren.find((child) => child.category?.slug === selectedKey)
          );

          if (subChildCategory) {
            setActiveKey(_id);
            setSubActiveKey(subChildCategory?.category?._id);
          }
        }
      });
    }
  }, [categories, selectedKey]);

  return (
    <div className="sidebar-widget">
      <h4 className="pro-sidebar-title">{t("productList.categories")}</h4>
      <div className="sidebar-widget-list mt-30">
        {categories ? (
          <Accordion activeKey={activeKey}>
            <ul>
              <ListItem itemKey="-1" name="" id="" />
              {Array.isArray(categories) &&
                categories
                  .filter(
                    (category) =>
                      category.status === "enabled" ||
                      category.category?.status === "enabled"
                  )
                  .map((category) => {
                    // Have Child Category
                    if (
                      Array.isArray(category.children) &&
                      category.children.length > 0 &&
                      category.children.filter(
                        ({ category: children }) =>
                          children.status === "enabled"
                      ).length > 0
                    ) {
                      return (
                        <li key={category.slug}>
                          <Accordion.Toggle
                            variant="link"
                            eventKey={category.slug}
                            style={{
                              paddingLeft: 10,
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                display: "inline",
                                paddingRight: 10,
                                fontSize: 16,
                              }}
                              onClick={() => {
                                if (category._id === activeKey) {
                                  setActiveKey(null);
                                  setSubActiveKey(null);
                                } else {
                                  setActiveKey(category._id);
                                }
                              }}
                              className="expand-sign"
                            >
                              {activeKey === category._id ? "-" : "+"}
                            </div>
                            <div
                              onClick={() =>
                                history.push({
                                  pathname: `/browse/${category.slug}`,
                                })}
                              className={`toggle-title ${
                                selectedKey === category.slug
                                  ? "theme-color"
                                  : ""
                              }`}
                            >
                              {getMultiLangProperty(
                                category.name,
                                i18n.language
                              )}
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={category._id}>
                            <ul style={{ marginTop: 10, paddingLeft: 30 }}>
                              {category.children
                                .filter(
                                  ({ category: children }) =>
                                    children.status === "enabled"
                                )
                                .map(
                                  ({ category: children = {} } = {}, index) => {
                                    // Have Child Category
                                    if (
                                      Array.isArray(children.children) &&
                                      children.children.length > 0 &&
                                      children.children.filter(
                                        ({ category: subChildren }) =>
                                          subChildren.status === "enabled"
                                      ).length > 0
                                    ) {
                                      return (
                                        <Accordion activeKey={subActiveKey}>
                                          <li
                                            key={children._id}
                                            style={{
                                              paddingBottom:
                                                index ===
                                                category.children.length - 1
                                                  ? 0
                                                  : 15,
                                            }}
                                          >
                                            <Accordion.Toggle
                                              variant="link"
                                              eventKey={children._id}
                                              style={{
                                                paddingLeft: 10,
                                                display: "flex",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "inline",
                                                  paddingRight: 10,
                                                  fontSize: 16,
                                                }}
                                                onClick={() => {
                                                  setSubActiveKey(
                                                    children._id ===
                                                      subActiveKey
                                                      ? null
                                                      : children._id
                                                  );
                                                }}
                                                className="expand-sign"
                                              >
                                                {subActiveKey === children._id
                                                  ? "-"
                                                  : "+"}
                                              </div>
                                              <div
                                                onClick={() => {
                                                  history.push({
                                                    pathname: `/browse/${children.slug}`,
                                                  });
                                                }}
                                                className={`toggle-title ${
                                                  selectedKey === children.slug
                                                    ? "theme-color"
                                                    : ""
                                                }`}
                                              >
                                                {getMultiLangProperty(
                                                  children.name,
                                                  i18n.language
                                                )}
                                              </div>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse
                                              eventKey={children._id}
                                            >
                                              <ul
                                                style={{
                                                  marginTop: 10,
                                                  paddingLeft: 30,
                                                }}
                                              >
                                                {children.children
                                                  .filter(
                                                    ({
                                                      category: subChildren,
                                                    }) =>
                                                      subChildren.status ===
                                                      "enabled"
                                                  )
                                                  .map(
                                                    ({
                                                      category: subChildren,
                                                    }) => (
                                                      <ListItem
                                                        slug={subChildren.slug}
                                                        name={getMultiLangProperty(
                                                          subChildren.name,
                                                          i18n.language
                                                        )}
                                                      />
                                                    )
                                                  )}
                                              </ul>
                                            </Accordion.Collapse>
                                          </li>
                                        </Accordion>
                                      );
                                    }

                                    // No Child Category
                                    return (
                                      <ListItem
                                        slug={children.slug}
                                        name={getMultiLangProperty(
                                          children.name,
                                          i18n.language
                                        )}
                                      />
                                    );
                                  }
                                )}
                            </ul>
                          </Accordion.Collapse>
                        </li>
                      );
                    }

                    // No Child Category
                    return (
                      <ListItem
                        slug={category.slug}
                        name={getMultiLangProperty(
                          category.name,
                          i18n.language
                        )}
                      />
                    );
                  })}
            </ul>
          </Accordion>
        ) : (
          <>{t("productList.noCategories")}</>
        )}
      </div>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopCategories;
